import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BabyStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M16 13.8128C16 11.7074 14.2057 9.99463 12 9.99463C9.79429 9.99463 8 11.7074 8 13.8128C8 14.5437 8.21714 15.2528 8.62857 15.8692C8.21714 16.5128 8 17.2492 8 18.0074C8 20.2055 9.79429 22.0001 12 22.0001C13.6571 22.0001 15.12 21.0074 15.7257 19.4583C15.9086 18.9946 16 18.5092 16 18.0074C16 17.2546 15.7829 16.5128 15.3714 15.8692C15.7829 15.2528 16 14.5492 16 13.8128ZM12 20.9037C10.4229 20.9037 9.14286 19.6055 9.14286 18.0019C9.14286 17.5601 9.24 17.1346 9.44 16.7364C9.92571 17.1237 10.4914 17.3964 11.0971 17.5274C11.6914 17.9746 13.0229 18.8637 14.4343 19.5292C13.92 20.3801 13 20.9037 12.0057 20.9037H12ZM12 12.9946C12.3943 12.9946 12.7657 12.8583 13.0629 12.6183C13.1771 12.5201 13.2457 12.3892 13.2571 12.2419C13.2686 12.0946 13.2171 11.9583 13.12 11.8437C13.0229 11.7346 12.88 11.6692 12.7314 11.6583C12.5829 11.6528 12.4286 11.6964 12.3143 11.7892C12.2286 11.8601 12.12 11.8983 12.0057 11.8983C11.7543 11.8983 11.5486 11.7128 11.5486 11.4892C11.5486 11.2655 11.7543 11.0801 12.0057 11.0801C13.5829 11.0801 14.8629 12.3019 14.8629 13.8074C14.8629 15.3128 13.5829 16.5346 12.0057 16.5346C10.4286 16.5346 9.14857 15.3128 9.14857 13.8074C9.14857 12.9074 9.62286 12.0728 10.4057 11.5655C10.4457 12.3564 11.1486 12.9892 12.0057 12.9892L12 12.9946ZM14.5657 16.7364C14.76 17.1346 14.8571 17.5601 14.8571 18.0019C14.8571 18.1655 14.8457 18.3292 14.8171 18.4928C14.1429 18.171 13.5086 17.8001 13.0286 17.4946C13.5886 17.3528 14.1143 17.091 14.5657 16.731V16.7364Z"
				fill="currentColor"
			/>
			<path
				d="M13.1486 14.3598C13.4629 14.3598 13.72 14.1143 13.72 13.8143C13.72 13.5143 13.4629 13.2688 13.1429 13.2688C12.8229 13.2688 12.5714 13.5143 12.5714 13.8143C12.5714 14.1143 12.8286 14.3598 13.1429 14.3598H13.1486Z"
				fill="currentColor"
			/>
			<path
				d="M10.8629 14.3598C11.1771 14.3598 11.4343 14.1143 11.4343 13.8143C11.4343 13.5143 11.1771 13.2688 10.8571 13.2688C10.5371 13.2688 10.2857 13.5143 10.2857 13.8143C10.2857 14.1143 10.5429 14.3598 10.8571 14.3598H10.8629Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BabyStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BabyStrokeIcon;
